import { SalesCommissionApi } from "src/api/generated/erp/sales/salesCommissions/api/salesCommissionApi.ts";
import { AsyncFetchRender } from "src/components/common/async/AsyncFetchRender.tsx";
import { SalesCommissionSourceType } from "src/components/views/erp/sales/salesCommissions/orderAndOfferViews/SalesCommissionSourceType.ts";
import { CustomerOrderOrOfferSalesCommissionLinesDataGrid } from "src/components/views/erp/sales/salesCommissions/orderAndOfferViews/CustomerOrderOrOfferSalesCommissionLinesDataGrid.tsx";
import { SalesCommissionInspectView } from "./SalesCommissionInspectView";
import { RefreshableElementRef } from "src/utils/useRefreshRef.ts";
import { Box, Divider } from "@mui/material";

export interface CustomerOrderOrOfferSalesCommissionViewProps {
	sourceType: SalesCommissionSourceType;
	sourceId: number;
	salesCommissionId: number;
	editingEnabled: boolean;
	salesCommissionViewRefreshRef?: RefreshableElementRef;
	hasManageCommissionPermission: boolean;
}

export const CustomerOrderOrOfferSalesCommissionView = ({
	salesCommissionId,
	sourceType,
	sourceId,
	editingEnabled,
	salesCommissionViewRefreshRef,
	hasManageCommissionPermission,
}: CustomerOrderOrOfferSalesCommissionViewProps) => {
	return (
		<AsyncFetchRender
			refreshRef={salesCommissionViewRefreshRef}
			fetch={() =>
				sourceType === "CUSTOMER_OFFER" ?
					SalesCommissionApi.getOfferSalesCommission({ salesCommissionId })
				:	SalesCommissionApi.getOrderSalesCommission({ salesCommissionId })
			}
			content={({ salesCommission, lines }, refresh) => (
				<Box
					sx={{
						flex: 1,
						display: "flex",
						minWidth: 0,
						minHeight: 0,
						flexDirection: {
							xs: "column",
							sm: "row",
						},
					}}
				>
					<SalesCommissionInspectView
						sourceType={sourceType}
						sourceId={sourceId}
						salesCommission={salesCommission}
						lines={lines}
						refreshData={refresh}
						editingEnabled={editingEnabled}
						hasManageCommissionPermission={hasManageCommissionPermission}
					/>
					<Divider
						sx={{
							borderColor: "grey.800",
						}}
					/>
					<CustomerOrderOrOfferSalesCommissionLinesDataGrid
						salesCommissionId={salesCommissionId}
						lines={lines}
						refreshData={refresh}
						sourceType={sourceType}
						editingEnabled={editingEnabled}
						hasManageCommissionPermission={hasManageCommissionPermission}
					/>
				</Box>
			)}
		/>
	);
};
